module.exports = __webpack_public_path__ + "static/img/poalim.f7eb6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/poalim.jpg
// module id = FW+e
// module chunks = 6